module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTE4IiB2aWV3Qm94PSIwIDAgMTAgMTE4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNC45OTk5OSAxMThMOS4zMzAxMiAxMTAuNUwwLjY2OTg2OCAxMTAuNUw0Ljk5OTk5IDExOFpNNC4yNSAtMy4yNzgzNWUtMDhMNC4yNSAxMTEuMjVMNS43NSAxMTEuMjVMNS43NSAzLjI3ODM1ZS0wOEw0LjI1IC0zLjI3ODM1ZS0wOFoiIGZpbGw9IiM1MTUxNTEiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Arrow-down-new.svg
// module id = hiu1
// module chunks = 134